import { render } from "./Deadline.vue?vue&type=template&id=7235c322&scoped=true"
import script from "./Deadline.vue?vue&type=script&lang=js"
export * from "./Deadline.vue?vue&type=script&lang=js"

import "./Deadline.vue?vue&type=style&index=0&id=7235c322&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7235c322"]])

export default __exports__